import {Injectable} from '@angular/core';
import {firstValueFrom, Observable, of} from "rxjs";
import { ApiHelperService } from 'src/app/core/helpers/api-helper.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    constructor(
        private api: ApiHelperService,
    ) {
    }

    getGetProfileInformation(): Observable<any> {
        return this.api.getAll(environment.GET_PROFILE_DETAIL);
    }

    changePassword(body: any): Observable<any> {
        return this.api.update(environment.CHANGE_PASSWORD, body);
    }

    resetPassword(body: any): Observable<any> {
        return this.api.create(environment.RESET_PASSWORD, body);
    }

    getLinkForgotPassword(body: any): Observable<any> {
        return this.api.create(environment.GET_LINK_RESET_PASSWORD, body);
    }

    getListPurchaseOrder(params: any): Observable<any> {
        return this.api.getAll(environment.GET_PURCHASE_ORDER_LIST, params);
    }

    getPurchaseOrderDetail(id: any): Observable<any> {
        return this.api.getById(environment.GET_PURCHASE_ORDER_DETAIL, id);
    }

    cancelPurchaseOrder(id: any): Observable<any> {
        return this.api.updateById(environment.CANCEL_PURCHASE_ORDER, id);
    }

    async getAllOrder(params?: any): Promise<any> {
        return await firstValueFrom(this.api.getAll(environment.ORDER_GET_ALL, params));
    }

    getApiKeys(params: any): Observable<any> {
        return this.api.getAll(environment.GET_API_KEYS_LIST, params);
    }

    getApiKeyDetail(id: any): Observable<any> {
        return this.api.getById(environment.GET_API_KEY_DETAIL, id);
    }

    createApiKey(body: any): Observable<any> {
        return this.api.create(environment.CREATE_API_KEY, body);
    }

    deleteApiKey(id: any): Observable<any> {
        return this.api.deleteById(environment.DELETE_API_KEY, id);
    }

    updateApiKey(id: any, body: any): Observable<any> {
        return this.api.patchById(environment.UPDATE_API_KEY, id, body);
    }

    addPacket(body: any): Observable<any> {
        return this.api.create(environment.PACKET_CREATE, body);
    }

    getPacketDetail(code: any): Observable<any> {
        return this.api.getById(environment.PACKET_GET_BY_ID, code);
    }

    editPacket(code: any, body: any): Observable<any> {
        return this.api.updateById(environment.PACKET_GET_BY_ID, code, body);
    }

    getAllPacket(params?: any): Observable<any> {
        return this.api.getAll(environment.PACKET_GET_ALL, params);
    }

    deletePacket(code: any): Observable<any> {
        return this.api.deleteById(environment.PACKET_GET_BY_ID, code);
    }

    getAllUser(params?: any): Observable<any> {
        return this.api.getAll(environment.GET_ALL_USER, params);
    }

    getPacketUsers(code: any): Observable<any> {
        return this.api.getById(environment.GET_PACKET_USERS, code);
    }

    addUserToPacket(body: any): Observable<any> {
        return this.api.create(environment.ADD_USER_TO_PACKET, body);
    }

    deleteUserFromPacket(body: any): Observable<any> {
        return this.api.deleteWithBody(environment.DELETE_PACKET_USERS, body);
    }

    getApiList(params?: any): Observable<any> {
        return this.api.getAll(environment.API_GET_ALL, params);
    }

    getApiDetail(id: any): Observable<any> {
        return this.api.getById(environment.API_GET_BY_ID, id);
    }

    addApi(body: any): Observable<any> {
        return this.api.create(environment.API_CREATE, body);
    }

    editApi(id: any, body: any): Observable<any> {
        return this.api.updateById(environment.API_UPDATE_BY_ID, id, body);
    }

    deleteApi(id: any): Observable<any> {
        return this.api.deleteById(environment.API_DELETE_BY_ID, id);
    }

    addPartner(body: any): Observable<any> {
        return this.api.create(environment.PARTNER_CREATE, body);
    }

    getPartnerList(params?: any): Observable<any> {
        return this.api.getAll(environment.PARTNER_GET_ALL, params);
    }

    getPartnerDetail(id: any): Observable<any> {
        return this.api.getById(environment.PARTNER_GET_BY_ID, id);
    }

    editPartner(id: any, body: any): Observable<any> {
        return this.api.updateById(environment.PARTNER_UPDATE_BY_ID, id, body);
    }

    deletePartner(id: any): Observable<any> {
        return this.api.deleteById(environment.PARTNER_DELETE_BY_ID, id);
    }

    uploadPartnerLogo(formData: FormData): Observable<any> {
        return this.api.postFormData(environment.FILE_UPLOAD_PATH, formData);
    }

    async getPricingPageConfig(params?: any): Promise<any> {
        return await firstValueFrom(this.api.getAll(environment.GET_PRICING_PAGE_CONFIG, params));
    }

    async updatePricingPageConfigEn(body: any): Promise<any> {
        return await firstValueFrom(this.api.update(environment.UPDATE_PRICING_PAGE_CONFIG_EN, body));
    }

    async updatePricingPageConfigVi(body: any): Promise<any> {
        return await firstValueFrom(this.api.update(environment.UPDATE_PRICING_PAGE_CONFIG_VI, body));
    }

    async createPolicy(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POLICY_CREATE, body));
    }

    async getPolicyList(params?: any): Promise<any> {
        return await firstValueFrom(this.api.getAll(environment.POLICY_GET_ALL, params));
    }

    async getPolicyDetail(id: any): Promise<any> {
        return await firstValueFrom(this.api.getById(environment.POLICY_GET_BY_ID, id));
    }

    async editPolicy(id: any, body: any): Promise<any> {
        return await firstValueFrom(this.api.updateById(environment.POLICY_UPDATE_BY_ID, id, body));
    }

    async activatePolicy(id: any): Promise<any> {
        return await firstValueFrom(this.api.updateById(environment.POLICY_ACTIVATE_BY_ID, id));
    }

    async deletePolicy(id: any): Promise<any> {
        return await firstValueFrom(this.api.deleteById(environment.POLICY_DELETE_BY_ID, id));
    }
}
